(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-personalization-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-personalization-guard')) {
    customElements.define('tt-personalization-guard', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form || this.observer) return;
        this.status = this.querySelector('[role="status"]');
        this.stock = JSON.parse(this.querySelector('[data-availability]').textContent);
        this.scope = this.closest('.shopify-section');
        this.pending = false;
        this.sync = this.sync.bind(this);
        this.onSubmit = (event) => {
          if (this.isReady()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.scope?.querySelector('.personalize-container button')?.focus();
          this.sync();
        };
        this.onChange = (event) => {
          const name = event.target.name || '';
          if (name === 'quantity' || name.startsWith('properties[')) return;
          this.pending = true;
          this.sync();
          clearTimeout(this.timer);
          // Printify restores or clears the saved design after a variant change.
          this.timer = setTimeout(() => { this.pending = false; this.sync(); }, 250);
        };
        this.form.addEventListener('submit', this.onSubmit, true);
        this.scope?.addEventListener('change', this.onChange, true);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
        this.sync();
      }
      isReady() {
        const variantId = this.form.querySelector('[name="id"]')?.value;
        const designId = this.form.querySelector('[name="properties[Personalization ID]"]')?.value.trim();
        return !this.pending && !!designId && this.stock.some(variant => variant.id === variantId && variant.available);
      }
      sync() {
        const ready = this.isReady();
        const button = this.form.querySelector('[name="add"]');
        // Respect Dawn's submitting state; never re-enable an in-flight button.
        if (button && !button.classList.contains('loading') && button.disabled === ready) button.disabled = !ready;
        const variantId = this.form.querySelector('[name="id"]')?.value;
        const inStock = this.stock.some(variant => variant.id === variantId && variant.available);
        const label = button?.querySelector(':scope > span');
        const buttonText = inStock ? this.dataset.addLabel : this.dataset.soldOutLabel;
        // Dawn interprets a server-rendered disabled button as sold out after a variant change.
        if (label && !button.classList.contains('loading') && label.textContent.trim() !== buttonText) label.textContent = buttonText;
        const text = ready ? this.dataset.ready : this.dataset.waiting;
        if (this.status.textContent !== text) this.status.textContent = text;
        this.dataset.readyState = String(ready);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.observer = null;
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.scope?.removeEventListener('change', this.onChange, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-preview-modal"] && !Shopify.designMode) return;
  try {
    class TapisPreviewModal extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.events = new AbortController();
    this.dialog = this.querySelector('dialog');
    const options = {signal:this.events.signal};
    this.querySelector('[data-mockup-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.dialog.addEventListener('close',()=>{
      document.body.style.overflow = this.overflow ?? '';
      this.opener?.focus();
    },options);
    this.querySelector('[data-thumbs]').addEventListener('click',event=>{
      const button = event.target.closest('button[data-index]');
      if (button) this.select(Number(button.dataset.index));
    },options);
    this.querySelector('[data-main-image]').addEventListener('error',()=>{
      this.querySelector('[data-mockup-status]').textContent=this.dataset.error;
    },options);
  }
  disconnectedCallback() {
    if(this.dialog?.open) { this.dialog.close(); document.body.style.overflow=this.overflow ?? ''; }
    this.events?.abort(); this.events=null;
  }
  open(opener) {
    if(this.dialog.open) return;
    this.opener=opener; this.overflow=document.body.style.overflow;
    document.body.style.overflow='hidden'; this.dialog.showModal();
  }
  reset() {
    this.images=[]; this.selected=0;
    this.querySelector('[data-mockup-gallery]').hidden=true;
    this.querySelector('[data-thumbs]').replaceChildren();
    this.querySelector('[data-main-image]').removeAttribute('src');
  }
  loading(active) {
    this.querySelector('[data-preview-loader]').hidden=!active;
    this.querySelector('[data-mockup-gallery]').setAttribute('aria-busy',String(active));
  }
  async setImages(images,signal) {
    this.reset();
    const safe=images.filter(src=>{
      try { const u=new URL(src); return u.protocol==='https:' && ['dsaujk5puqrkx.cloudfront.net','images.printify.com','cdn.shopify.com'].includes(u.hostname); } catch { return false; }
    }).slice(0,8);
    if(!safe.length) throw new Error('preview_failed');
    const pending=Promise.all(safe.map(src=>{
      const image=new Image(); image.src=src;
      return image.decode().then(()=>src,()=>null);
    }));
    const loaded=await new Promise((resolve,reject)=>{
      const abort=()=>reject(new DOMException('Aborted','AbortError'));
      if(signal?.aborted) return abort();
      signal?.addEventListener('abort',abort,{once:true});
      const timeout=setTimeout(()=>reject(new Error('preview_failed')),30000);
      pending.then(resolve,reject).finally(()=>{clearTimeout(timeout);signal?.removeEventListener('abort',abort);});
    });
    if(signal?.aborted || !this.isConnected) throw new DOMException('Aborted','AbortError');
    this.images=loaded.filter(Boolean);
    if(!this.images.length) throw new Error('preview_failed');
    const thumbs=this.querySelector('[data-thumbs]');
    this.images.forEach((src,index)=>{
      const button=document.createElement('button'); button.type='button'; button.dataset.index=index;
      button.setAttribute('aria-label',`${this.dataset.view} ${index+1}`);
      const image=document.createElement('img'); image.src=src; image.alt=''; image.width=96; image.height=96;
      button.append(image); thumbs.append(button);
    });
    this.select(0); this.querySelector('[data-mockup-gallery]').hidden=false;
  }
  select(index) {
    if(!this.images?.[index]) return;
    this.selected=index;
    const main=this.querySelector('[data-main-image]');
    main.src=this.images[index]; main.alt=`${this.dataset.alt} — ${index+1}`;
    this.querySelectorAll('[data-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  }
}
if(!customElements.get('tt-preview-modal')) customElements.define('tt-preview-modal',TapisPreviewModal);

class TapisCartPreview extends HTMLElement {
  connectedCallback() {
    if(this.events) return;
    this.events=new AbortController();
    this.querySelector('[data-open-preview]').addEventListener('click',async event=>{
      event.preventDefault();
      const opener=event.currentTarget;
      await customElements.whenDefined('tt-preview-modal');
      if(!this.isConnected) return;
      const modal=this.querySelector('tt-preview-modal'); modal.open(opener);
      if(modal.images?.length) return;
      modal.loading(true);
      const status=modal.querySelector('[data-mockup-status]'); status.textContent=this.dataset.loading;
      try {
        const urls=JSON.parse(this.querySelector('[data-cart-previews]').textContent);
        await modal.setImages(urls,this.events.signal);
        const selected=modal.images.findIndex(src=>src.trim()===this.dataset.primary);
        if(selected>=0) modal.select(selected);
        status.textContent='';
      } catch { status.textContent=modal.dataset.error; }
      finally { modal.loading(false); }
    },{signal:this.events.signal});
  }
  disconnectedCallback() { this.events?.abort(); this.events=null; }
}
if(!customElements.get('tt-cart-preview')) customElements.define('tt-cart-preview',TapisCartPreview);
  } catch(e) { console.error(e); }
})();

})();
